document.addEventListener('DOMContentLoaded', function () {
  var menuToggle = document.getElementById('menuToggle');
  var mobileMenu = document.getElementById('mobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isHidden = mobileMenu.hasAttribute('hidden');
      if (isHidden) {
        mobileMenu.removeAttribute('hidden');
        menuToggle.setAttribute('aria-expanded', 'true');
      } else {
        mobileMenu.setAttribute('hidden', '');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.setAttribute('hidden', '');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Product variant pills: selecting a pill submits the form with ?variant=ID
  // so the page reloads with correct price/availability (no AJAX cart dependency).
  document.querySelectorAll('[data-variant-selector]').forEach(function (form) {
    form.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var variantId = input.value;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.location.href = url.toString();
      });
    });
  });

  // Product gallery thumbnails: click to swap the main product image.
  var mainProductImage = document.getElementById('mainProductImage');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainProductImage) return;
      mainProductImage.src = thumb.getAttribute('data-full-src');
      mainProductImage.alt = thumb.getAttribute('data-alt') || mainProductImage.alt;
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});
